<div>
	<app-spin-or-content [isSpin]="isLoading">
		@if (personTypesShown) {
			<div class="d-flex">
				<div class="colstat colstat-big pad-btns">
					<app-gen-input
						[actualObj]="this"
						fieldName="search"
					/>
				</div>

				<div class="colstat colstat-big pad-btns">
					<app-gen-button-group
						[actualObj]="this"
						fieldName="active"
						optionsListName="active_all_opts"
						(changeEvent)="resetShown()"
					/>
				</div>

				<div class="colstat colstat-small-triple pad-btns">
					<app-gen-button-group
						[actualObj]="this"
						fieldName="inviteFillOpt"
						optionsListName="policy_invite_fill_opts"
						(changeEvent)="resetShown()"
					/>
				</div>
			</div>

			@for (typeObj of personTypesShown | keyvalue; track typeObj.key) {
				<div>
					<div
						class="section-row"
						[style.background-color]="'lightblue'"
						(click)="isOpened[typeObj.key] = !isOpened[typeObj.key]"
					>
						<button
							class="btn btn-icon"
							titleLang="expand"
							icon="report_expand"
						></button>
						<h4 class="gen-title">{{ typeObj.key | langVal }}</h4>
					</div>

					@if (isOpened[typeObj.key]) {
						<h4 class="gen-title">{{ "signing_state" | langVal }}</h4>
						<div>
							<app-check
								(onClick)="checkAll(typeObj.key)"
								[isCheck]="isAllChecked[typeObj.key]"
							/>
						</div>
						<list
							[arr]="typeObj.value"
							[type]="typeObj.key"
							[search]="search"
							[latestVersionId]="latestVersion.id"
							(onCheck)="check($event)"
							(filled)="loadPersonTypesObj()"
						/>
					}
				</div>
			}
			<div class="modal-btns">
				<app-btn-ext
					[disabled]="!isFormSubmittable"
					(clickEv)="submit()"
					text="submit"
					[isSpin]="isSending"
				/>
			</div>
		}
	</app-spin-or-content>
</div>
